@if (isLoading$ | async) {
  <ng-container *transloco="let t">
    <div aria-live="polite" class="container">
      <p-progressSpinner/>
      <div class="spinner-text">{{ t('loading') }}</div>
    </div>
  </ng-container>
}